<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 14:34:17
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-31 11:31:41
 * @FilePath: /wemeet-admin-new/src/views/data/components/userPie.vue
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
-->
<template>
  <el-row :gutter="20">
    <el-col class="ul" :lg="12" :md="24" :sm="24" :xl="12" :xs="24">
      <div class="dialogCard">
        <div class="subBox">
          <div class="title">用户身份</div>
          <div class="subTitle">更新时间：{{ nowTime }}</div>
        </div>

        <el-row>
          <div v-if="loading">加载中...</div>
          <template v-else>
            <el-col class="ul" :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
              <vab-chart
                v-if="identity.length > 0"
                :option="identityOption"
                style="height: 390px; width: 100%"
                theme="vab-echarts-theme"
              />
              <noDataVue v-else style="height: 390px; width: 100%" />
            </el-col>
          </template>
        </el-row>
      </div>
    </el-col>
    <el-col class="ul" :lg="12" :md="24" :sm="24" :xl="12" :xs="24">
      <div class="dialogCard">
        <div class="subBox">
          <div class="title">实名方式</div>
          <div class="subTitle">更新时间：{{ nowTime }}</div>
        </div>

        <el-row>
          <div v-if="loading">加载中...</div>
          <template v-else>
            <el-col class="ul" :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
              <vab-chart
                v-if="realData.length > 0"
                :option="realOption"
                style="height: 390px; width: 100%"
                theme="vab-echarts-theme"
              />
              <noDataVue v-else style="height: 390px; width: 100%" />
            </el-col>
          </template>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'
  import noDataVue from './noData.vue'
  export default defineComponent({
    components: {
      VabChart,
      VabCount,
      noDataVue,
    },
    props: {
      identity: {
        type: Array,
        default: [],
      },
      realData: {
        type: Array,
        default: [],
      },
      nowTime: {
        type: String,
        default: '',
      },
    },
    setup(props) {
      watch(
        () => [props.identity, props.realData],
        ([identity, realData]) => {
          console.log(identity, '====>>>')
          handleidentityOption(identity, realData)
          setTimeout(() => {
            state.loading = false
          }, 100)
        },
        {
          deep: true,
        }
      )
      const state = reactive({
        loading: true,
        countConfig: {
          startVal: 0,
          endVal: _.random(1000, 5555),
          decimals: 0,
          prefix: '',
          suffix: '',
          separator: ',',
          duration: 8000,
          suf: '次',
        },
        identityOption: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}  {c}人 <br/> 占比 {d}%',
          },
          grid: {
            top: 'top',
          },
          legend: {
            top: 'bottom',
            left: 'center',
          },
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2,
                },
              },
              labelLine: {
                show: true,
              },
              center: ['50%', '40%'],
              data: [],
            },
          ],
        },
        realOption: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}  {c}人 <br/> 占比 {d}%',
          },
          grid: {
            top: 'top',
          },
          legend: {
            top: 'bottom',
            left: 'center',
          },
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2,
                },
              },
              labelLine: {
                show: true,
              },
              data: [],
            },
          ],
        },
        identityCard: {
          CERTIFICATES_TYPE_1: '身份证',
          CERTIFICATES_TYPE_2: '回乡证',
          CERTIFICATES_TYPE_3: '台胞证',
          CERTIFICATES_TYPE_4: '外国人永久居住证',
          CERTIFICATES_TYPE_5: '外国护照',
          CERTIFICATES_TYPE_6: '军人证',
          CERTIFICATES_TYPE_7: '外国人手机验证码认证',
          CERTIFICATES_TYPE_8: '港澳台居民居住证',
          CERTIFICATES_TYPE_99: '其他',
        },
      })

      const handleidentityOption = (val, realData) => {
        let seriesData = []
        let seriesData1 = []
        val.forEach((v) => {
          let obj = {
            value: '',
            name: '',
          }
          obj.value = v.data
          obj.name = v.name
          seriesData.push(obj)
        })
        realData.forEach((v) => {
          let obj = {
            value: '',
            name: '',
          }
          obj.value = v.data
          obj.name = v.label == '其他' ? '其他' : state.identityCard[v.label]
          seriesData1.push(obj)
        })
        console.log('LRC LOG', seriesData)
        state.identityOption.series[0].data = seriesData
        state.realOption.series[0].data = seriesData1
      }
      return {
        ...toRefs(state),
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;

    .subBox {
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
      }

      .subTitle {
        font-size: 12px;
        color: #4e5969;
      }
    }

    .ul {
      margin-top: 15px;

      .smTitle {
        font-size: 16px;
        color: #1d2129;
      }
    }
  }
</style>
